import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum ObstructionTypeSectionIds {
  general = 'general',
  symbol = 'symbol',
}

/**
 * @description Sections shared by the Obstruction Type detail page and edit form, in display order.
 */
export const obstructionTypeSections: SectionDefinition[] = [
  {
    id: ObstructionTypeSectionIds.general,
    title: 'General',
    description: 'Name of the obstruction type and its position in lists.',
    icon: InfoOutlinedIcon,
  },
  {
    id: ObstructionTypeSectionIds.symbol,
    title: 'Symbol',
    description: 'Emoji that represents this obstruction type.',
    icon: EmojiEmotionsOutlinedIcon,
  },
]
